<template>
  <div class="painPoint">
    <div class="left">
        <div class="leftName">BOSS痛点决解方案</div>
        <div class="imgName">
            <img :class="'imgName_'+index" class="wow animate__animated animate__bounceInLeft" :data-wow-delay ="item.time+'s'" :src="item.icon" alt="" v-for="(item,index) in painimagesList" :key="index+'_img'">
        </div>
    </div>
    <div class="right">
        <ul class="right_content">
            <li class="wow animate__animated animate__fadeInRightBig" v-for="(item,index) in painList" :key="index">
                <div class="icon">
                    <img :src="item.icon" alt="">
                </div>
                <div class="content">
                    <div class="name">{{item.name}}</div>
                    <div class="explain">{{item.explain}}</div>
                </div>
            </li>
        </ul>
        <div class="item_bottom">
            <div class="ontrial"><img src="../../../../../public/images/free.png" alt=""> 免费试用</div>
            <div class="consult"><img class="be" src="../../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
        </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {
        
    },
    data(){
        return{
            painimagesList:[
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/1.png',
                    time:0.4
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/2.png',
                    time:0.8
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/3.png',
                    time:1.2
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/4.png',
                    time:1.6
                },
            ],
            painList:[
                {
                    icon:require('@/assets/icon/ym/index2.png'),
                    name:'库存汇总',
                    explain:'库存资源表格汇总查询一目了然',
                    time:0.1
                },
                {
                    icon:require('@/assets/icon/ym/index3.png'),
                    name:'销售统计',
                    explain:'每笔订单销售利润自动计算，盈利亏损心中有数',
                    time:0.2
                },
                {
                    icon:require('@/assets/icon/ym/index4.png'),
                    name:'成本查看',
                    explain:'随时随地，方便快捷地查看成本单价和销售单价',
                    time:0.3
                },
                {
                    icon:require('@/assets/icon/ym/index1.png'),
                    name:'库存分析',
                    explain:'实时分析库存比例，让BOSS采购、销售利润了然于心',
                    time:0.4
                },
                {
                    icon:require('@/assets/icon/ym/index5.png'),
                    name:'销售分析',
                    explain:'多维度销售分析，让销售管理更科学',
                    time:0.5
                },
                {
                    icon:require('@/assets/icon/ym/index6.png'),
                    name:'客户分析',
                    explain:'多维度销售分析，让销售管理更科学',
                    time:0.6
                },
                {
                    icon:require('@/assets/icon/ym/index7.png'),
                    name:'库存预警',
                    explain:'系统自动预警最低和最高库存量，方便公司及时采购货物 和促销积压库存',
                    time:0.7
                },
                {
                    icon:require('@/assets/icon/ym/index8.png'),
                    name:'付款提醒',
                    explain:'采购合同订单即将到港时，提前7-10天提醒财务准备付款',
                    time:0.8
                },
                {
                    icon:require('@/assets/icon/ym/index9.png'),
                    name:'收款提醒',
                    explain:'实时监控提醒每笔预收款，有效避免遗忘收款',
                    time:0.9
                },
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{
        
    }
}
</script>

<style scoped  lang="scss">
    .painPoint{
        display: flex;
        .left{flex: 1;padding: 2rem 5rem;
            display: flex;
            flex-direction: column;
            .leftName{
                font-size: 2.2rem;
                font-weight: 600;
            }
            .imgName{
                display: flex;
                position: relative;
                height: 100%;
                padding: 3rem 0;
                overflow: hidden;
            }
            .imgName_0{
                position: absolute;
                left: 0;
                top: 4rem;
                z-index: 10;
            }
            .imgName_1{
                position: absolute;
                left: 8rem;
                top: 5.2rem;
                z-index: 6;
            }
            .imgName_2{
                position: absolute;
                left: 16rem;
                top: 7rem;
                z-index: 4;
            }
            .imgName_3{
                position: absolute;
                left: 24rem;
                top: 8.2rem;
                z-index: 2;
            }
        }
        .right{
            flex: 1;
            padding: 2rem 0;
            .right_content{
                >li{
                    display: flex;
                    margin-top: 1.3rem;
                    .icon{
                        flex-basis: 4rem;
                        font-size: 2rem;
                        color: #537EF0;
                    }
                    .name{font-size: 1.6rem;font-weight: 600;}
                    .explain{font-size: 1.4rem;color: #5D5D5D;margin-top: 0.5rem;}
                }
            }
        }
    }
    .item_bottom{
        margin: 1.2rem 0 0 4rem;
    }
</style>
